/* Tabs */
if ($('.tabs').length) {
    $('.tabs li').click(function () {
        var $this = $(this);
        var $theTab = $(this).attr('id');
        console.log($theTab);
        if ($this.hasClass('active')) {
            //
        } else {
            $this.closest('.tabs_wrapper').find('ul.tabs li, .tabs_container .tab_content').removeClass('active');
            $('.tabs_container .tab_content[data-tab="' + $theTab + '"], ul.tabs li[id="' + $theTab + '"]').addClass('active');
        }
    });
}
/* Footer links */
$(document).on("click",".footer-top__column-title",function() {
    $(this).closest('.footer-top__column').toggleClass('ft-active');
});
/* Mobile menu */
$(document).on("click",".header-burger",function() {
    $('html,body').addClass('fl-scroll-hidden');
    $('.app-mobile-menu').addClass('mobile-menu-active');
    $('body').addClass('body-mobile-menu-active');
    // $(this).addClass('header-burger-active');
    // $(this).removeClass('header-burger');

});
$(document).on("click",".header-burger-active",function() {
    $('html,body').removeClass('fl-scroll-hidden');
    $('.app-mobile-menu').removeClass('mobile-menu-active');
    // $(this).addClass('header-burger');
    // $(this).removeClass('header-burger-active');
});
$(document).on("click",".app-mobile-menu .app-nav > ul > li > .site-nav__link",function (e) {
    e.preventDefault();
    if(!$(this).closest("li").hasClass("single-link")){
        if($(this).closest("li").hasClass("site-nav-active")){
            $(this).closest("li").removeClass("site-nav-active");
            $(this).closest("ul").find(">li:not(.site-nav-active)").show();
            $('.mobile-action-bar').show();
        } else {
            $(this).closest("li").addClass("site-nav-active");
            $(this).closest("ul").find(">li:not(.site-nav-active)").hide();
            $('.mobile-action-bar').hide();
        }
    }else {window.location.href = $(this).attr("href");}
    //$(this).closest("li").find('.dropdown-shownav').find(".sbprod").toggleClass("site-nav-child-active");

})
$(document).on("click",".app-mobile-menu .app-nav li .sub-megamenu .link-wrapper .sbprod .fst-title",function (e) {
    e.preventDefault();
    $(this).closest(".sbprod").toggleClass("site-nav-child-active");
})
$(document).on("click",".app-mobile-menu .app-nav li .sub-megamenu .link-wrapper .sbprod .snd-title",function (e) {
    e.preventDefault();
    $(this).closest(".sbprod").toggleClass("site-nav-child-active");
})
/* Modals */
$('[open-modal]').on('click', function(){
    var id = $(this).attr('open-modal');
    $('.modal#'+id).addClass('active');
});
$('[close-modal]').on('click', function(){
    $(this).parents('.modal').removeClass('active');
});
$('.modal').on('click', function(e) {
    if(e.target !== this){return};
    $(this).removeClass('active');
});
/* Catalog */
$(".view-switcher").on("click",function (e) {
    $(".view-switcher").removeClass('view-active');
    let dataView = $(this).data("view");
    $(this).addClass('view-active');
    $(".grid-uniform").removeClass('grid-view list-view').addClass($(this).data('view'));
});


$(document).on("click",".js-load-more",function () {
    var $this = $(this),
        totalPages = parseInt($('[data-all-pages]').val()),
        currentPage = parseInt($('[data-this-page]').val()),
        datacollurl = $('[data-coll-url]').val().split('?')[0];
    $this.attr('disabled', true);
    $this.find('[load-more-text]').addClass('hide');
    $this.find('[loader]').removeClass('hide');
    var nextUrl = $('[data-next-link]').val();
    var current_page_new = currentPage + 1;
    var next_coll = currentPage + 2;
    var search =  $('[data-coll-q]').val();
    var q="";
    if(search!== null && search!==undefined){
        q="&q="+search
    }else if($('[data-coll-url]').val().split('?')[1].includes("filter")){
        q="&"+$('[data-coll-url]').val().split('?')[1]
    }
    //alert(current_page_new)
    //return false;
    $.ajax({
        url: nextUrl,
        type: 'GET',
        dataType: 'html',
        success: function (responseHTML) {
            $('[data-next-link]').val(datacollurl + '?page=' + next_coll+q);
            $('[data-this-page]').val(current_page_new);
            $('.product-grid-container #product-grid').append(
                $(responseHTML).find('.product-grid-container #product-grid').html()
            );
        },
        complete: function () {
            if (current_page_new < totalPages) {
                $this.attr('disabled', false);
                $this.find('[load-more-text]').removeClass('hide');
                $this.find('[loader]').addClass('hide');
            }
            if (current_page_new >= totalPages) {
                $this.find('[load-more-text]').text('ALL PRODUCTS SHOWN').removeClass('hide');
                $this.find('[loader]').addClass('hide');
                $(".collection-top-icon").show();
            }
            
            // Integración con sistema dinámico de banners
            setTimeout(function(){ 
                // Reinsertar banners después de cargar más productos
                if (typeof window.insertBannersInGrid === 'function') {
                    window.insertBannersInGrid();
                }
                
                // Actualizar contador de productos (excluyendo banners dinámicos)
                const count = document.querySelectorAll('#product-grid li:not(.banner-dynamic)').length;            
                const countInfo = document.querySelector('.collection-count-info');
                if (countInfo) {
                    countInfo.innerHTML ="<span>Showing </span> <span>"+count+"</span> <span>DESIGNS</span>";
                }
            }, 800);  
            
            // Optimización de imágenes lazy loading
            document.querySelectorAll('img[loading="lazy"]').forEach(function(img) {
                if (!img.complete || img.naturalWidth === 0) {
                    const newImg = img.cloneNode(true);
                    const src = img.getAttribute('data-src');
                    if (src) {
                        src.replace(/^\/\//, 'https://');
                        img.removeAttribute('src');
                        newImg.setAttribute('src', src);
                        img.parentNode.replaceChild(newImg, img);
                    }
                }
            });
        },
    });

});

// Scroll infinito deshabilitado - ahora es solo botón manual
// $(document).ready(function () {
//     $(window).scroll(function (){
//             if($(".load-more_wrap").length>0 && ($(window).scrollTop() + $(window).height() - 100 > $(".load-more_wrap").offset().top) && $( ".load-more_wrap .btn" ).attr("disabled")!="disabled"){
//                 $( ".load-more_wrap .btn" ).trigger( "click" );
//             }
//         }
//     );
// });


(function(){
    function onReady() {
        setTimeout(() => {
            document.body.classList.remove('no-scroll');
            window.scrollTo(0, 0);
        }, 10);

    }

    if ( document.readyState === 'complete' ) {
        onReady();
    } else {
        document.addEventListener('DOMContentLoaded', onReady);
    }
})();
